import { Trans } from '@lingui/macro';
import React from 'react';
import { Link } from 'react-router-dom';
const MenuSignUp = (props) => {
  const { type, redirectParam } = props;
  return (
    <>
      {(!type || type == 1) && (
        <>
          <div className="z-10 item-selection active cursor-pointer relative">
            <Link
              to={`?type=1${redirectParam ? '&redirect=' + redirectParam : ''}`}
            >
              <div className="flex items-center overflow-hidden ">
                <svg
                  width="9"
                  height="20"
                  viewBox="0 0 9 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.27586 4.40327C5.49179 4.40327 6.47749 3.41757 6.47749 2.20164C6.47749 0.985706 5.49179 0 4.27586 0C3.05993 0 2.07422 0.985706 2.07422 2.20164C2.07422 3.41757 3.05993 4.40327 4.27586 4.40327Z"
                    fill="white"
                  />
                  <path
                    d="M5.70003 5.03736H2.85001C2.12589 5.00836 1.41972 5.26708 0.88572 5.75702C0.351724 6.24696 0.0333017 6.92831 0 7.65224V11.3929C0.0113229 11.8151 0.154962 12.2232 0.410644 12.5594C0.666326 12.8956 1.02114 13.143 1.42501 13.2668V18.3683C1.40141 18.7727 1.5375 19.1703 1.80399 19.4754C2.07048 19.7805 2.44609 19.9689 2.85001 19.9999H5.70003C6.10396 19.9689 6.47957 19.7805 6.74606 19.4754C7.01255 19.1703 7.14863 18.7727 7.12504 18.3683V13.2668C7.5289 13.143 7.88372 12.8956 8.1394 12.5594C8.39508 12.2232 8.53872 11.8151 8.55005 11.3929V7.65224C8.51674 6.92831 8.19832 6.24696 7.66433 5.75702C7.13033 5.26708 6.42415 5.00836 5.70003 5.03736Z"
                    fill="white"
                  />
                </svg>

                <div style={{ marginLeft: '13px', color: '#FFF' }}>
                  <Trans>Cá nhân</Trans>
                </div>
              </div>
            </Link>

            <div className="rounder1 absolute">
              <svg
                width="86"
                height="73"
                viewBox="0 0 86 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M71.9429 9.75945C77.9382 9.77498 85.5153 8.61899 85.5058 12.2813L85.3669 65.8836C85.3574 69.5459 80.4896 72.5022 74.4943 72.4866L19.3124 72.3437C8.4569 72.3155 8.4569 72.3156 8.47408 65.6843C3.95097 65.6726 65.8023 65.8329 71.7976 65.8484L71.9429 9.75945Z"
                  fill="#2F7DBF"
                />
                <path
                  d="M67.895 0.907423C73.8903 0.922956 78.7428 3.90444 78.7333 7.56676L78.5944 61.169C78.585 64.8313 73.7171 67.7876 67.7218 67.7721L12.5399 67.6292C6.54456 67.6136 1.6921 64.6321 1.70159 60.9698C-7.34463 60.9464 67.739 61.1409 67.739 61.1409L67.895 0.907423Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="rounder absolute z-0">
              <svg
                width="130"
                height="94"
                viewBox="0 0 130 94"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9998 15C15.9998 8.37258 13.8723 0 20.4998 0H117.5C124.127 0 129.5 5.37258 129.5 12V73C129.5 85 129.5 85 117.5 85C117.5 90 117.5 21.6274 117.5 15H15.9998Z"
                  fill="#2F7DBF"
                />
                <path
                  d="M0 19.5C0 12.8726 5.37258 7.5 12 7.5H109C115.627 7.5 121 12.8726 121 19.5V80.5C121 87.1274 115.627 92.5 109 92.5C109 102.5 109 19.5 109 19.5H0Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
          <Link
            to={`?type=2${redirectParam ? '&redirect=' + redirectParam : ''}`}
          >
            <div className="z-10 flex items-center item-selection cursor-pointer overflow-hidden">
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.4266 7.60216C11.5514 7.60216 11.6716 7.62221 11.7874 7.65561L13.9475 5.00779C14.0856 4.83855 14.3417 4.80737 14.5087 4.94989C14.6713 5.08574 14.6935 5.32847 14.5577 5.49326L12.4221 8.11213C12.5668 8.31255 12.6537 8.55977 12.6537 8.827C12.6537 9.3236 12.3553 9.7534 11.9299 9.94489H20.3098C20.6172 9.94489 20.8666 9.6955 20.8666 9.38816V2.33993C20.8666 2.03262 20.6172 1.7832 20.3098 1.7832H9.66513C9.35781 1.7832 9.1084 2.03262 9.1084 2.33993V6.96749L9.61168 7.60439H11.4266V7.60216Z"
                  fill="#007CC2"
                />
                <path
                  d="M4.4835 4.56075C5.74292 4.56075 6.76387 3.53979 6.76387 2.28037C6.76387 1.02096 5.74292 0 4.4835 0C3.22408 0 2.20312 1.02096 2.20312 2.28037C2.20312 3.53979 3.22408 4.56075 4.4835 4.56075Z"
                  fill="#007CC2"
                />
                <path
                  d="M6.82108 19.4431C6.82108 19.7505 6.57166 19.9999 6.26435 19.9999H5.32904C5.02172 19.9999 4.77231 19.7505 4.77231 19.4431V14.7755C4.77231 14.6107 4.63869 14.4771 4.4739 14.4771C4.30911 14.4771 4.17549 14.6107 4.17549 14.7755V19.4209C4.17549 19.7393 3.91494 19.9999 3.59649 19.9999H2.68122C2.37391 19.9999 2.12449 19.7505 2.12449 19.4431L2.12004 8.17489C2.12004 8.02346 1.99755 7.89877 1.8439 7.89877C1.69247 7.89877 1.56776 8.02125 1.56776 8.17489V12.5085C1.56776 12.8158 1.31834 13.0652 1.01103 13.0652H0.556732C0.249416 13.0652 0 12.8158 0 12.5085V6.56705C0 5.86111 0.57232 5.29102 1.27603 5.29102H6.34674C6.89009 5.29102 7.40454 5.54043 7.74303 5.96578L9.10589 7.68496L9.39316 8.04795C9.39316 8.04795 10.6848 8.04795 11.4286 8.05018C11.7359 8.05018 11.9853 8.2996 11.9853 8.60691V9.05007C11.9853 9.35739 11.7359 9.6068 11.4286 9.6068H9.01906C8.78078 9.6068 8.55586 9.49768 8.40888 9.3106L7.3934 8.00562C7.34218 7.93881 7.25979 7.89873 7.17516 7.89873H7.10613C6.9547 7.89873 6.83001 8.02121 6.83001 8.17484L6.82108 19.4431Z"
                  fill="#007CC2"
                />
              </svg>

              <div style={{ marginLeft: '13px' }}>
                <Trans>Nhà trường</Trans>
              </div>
              <div className="rounder1 absolute">
                <svg
                  width="86"
                  height="73"
                  viewBox="0 0 86 73"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M71.9429 9.75945C77.9382 9.77498 85.5153 8.61899 85.5058 12.2813L85.3669 65.8836C85.3574 69.5459 80.4896 72.5022 74.4943 72.4866L19.3124 72.3437C8.4569 72.3155 8.4569 72.3156 8.47408 65.6843C3.95097 65.6726 65.8023 65.8329 71.7976 65.8484L71.9429 9.75945Z"
                    fill="#2F7DBF"
                  />
                  <path
                    d="M67.895 0.907423C73.8903 0.922956 78.7428 3.90444 78.7333 7.56676L78.5944 61.169C78.585 64.8313 73.7171 67.7876 67.7218 67.7721L12.5399 67.6292C6.54456 67.6136 1.6921 64.6321 1.70159 60.9698C-7.34463 60.9464 67.739 61.1409 67.739 61.1409L67.895 0.907423Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="rounder absolute">
                <svg
                  width="130"
                  height="94"
                  viewBox="0 0 130 94"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.9998 15C15.9998 8.37258 13.8723 0 20.4998 0H117.5C124.127 0 129.5 5.37258 129.5 12V73C129.5 85 129.5 85 117.5 85C117.5 90 117.5 21.6274 117.5 15H15.9998Z"
                    fill="#2F7DBF"
                  />
                  <path
                    d="M0 19.5C0 12.8726 5.37258 7.5 12 7.5H109C115.627 7.5 121 12.8726 121 19.5V80.5C121 87.1274 115.627 92.5 109 92.5C109 102.5 109 19.5 109 19.5H0Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </Link>
          <Link
            to={`?type=3${redirectParam ? '&redirect=' + redirectParam : ''}`}
          >
            <div
              href="/user/signup?role=enterprise"
              className="z-10 flex items-center item-selection cursor-pointer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.51562 7.10938C2.22301 7.10938 1.17188 6.05824 1.17188 4.76562C1.17188 3.47301 2.22301 2.42188 3.51562 2.42188C4.80824 2.42188 5.85938 3.47301 5.85938 4.76562C5.85938 6.05824 4.80824 7.10938 3.51562 7.10938Z"
                  fill="#007CC2"
                />
                <path
                  d="M16.4844 7.10938C15.1918 7.10938 14.1406 6.05824 14.1406 4.76562C14.1406 3.47301 15.1918 2.42188 16.4844 2.42188C17.777 2.42188 18.8281 3.47301 18.8281 4.76562C18.8281 6.05824 17.777 7.10938 16.4844 7.10938Z"
                  fill="#007CC2"
                />
                <path
                  d="M10 5.85938C8.38465 5.85938 7.07031 4.54504 7.07031 2.92969C7.07031 1.31434 8.38465 0 10 0C11.6154 0 12.9297 1.31434 12.9297 2.92969C12.9297 4.54504 11.6154 5.85938 10 5.85938Z"
                  fill="#007CC2"
                />
                <path
                  d="M10.5859 5.91797V9.96032C10.5859 10.2842 10.3239 10.5463 10 10.5463C9.67613 10.5463 9.41406 10.2842 9.41406 9.96032V5.91797C7.43164 6.20535 5.89844 7.89957 5.89844 9.96032V13.4759C5.89844 13.7998 6.16051 14.0619 6.48438 14.0619H7.79703L8.24449 19.4627C8.26965 19.7659 8.52371 19.9994 8.82812 19.9994H11.1719C11.4763 19.9994 11.7304 19.7659 11.7555 19.4627L12.203 14.0619H13.5156C13.8395 14.0619 14.1016 13.7998 14.1016 13.4759V9.96032C14.1016 7.89957 12.5684 6.20535 10.5859 5.91797Z"
                  fill="#007CC2"
                />
                <path
                  d="M4.6875 13.5547V10.0391C4.6875 9.16078 4.92383 8.34461 5.30512 7.61555C4.77898 7.30148 4.17164 7.10938 3.51562 7.10938C1.57699 7.10938 0 8.68637 0 10.625V13.5547C0 13.8786 0.26207 14.1406 0.585938 14.1406H1.22738L1.76066 19.4724C1.79043 19.7717 2.04277 20 2.34375 20H4.6875C4.98848 20 5.24082 19.7717 5.27059 19.4724L5.70367 15.1426C5.10543 14.8619 4.6875 14.2581 4.6875 13.5547Z"
                  fill="#007CC2"
                />
                <path
                  d="M19.9996 10.625C19.9996 8.68637 18.4226 7.10938 16.4839 7.10938C15.8279 7.10938 15.2206 7.30148 14.6945 7.61555C15.0757 8.34461 15.3121 9.16078 15.3121 10.0391V13.5547C15.3121 14.2581 14.8941 14.8619 14.2959 15.1426L14.729 19.4724C14.7588 19.7717 15.0111 20 15.3121 20H17.6558C17.9568 20 18.2091 19.7717 18.2389 19.4724L18.7722 14.1406H19.4136C19.7375 14.1406 19.9996 13.8786 19.9996 13.5547V10.625Z"
                  fill="#007CC2"
                />
              </svg>
              <div style={{ marginLeft: '13px' }}>
                <Trans>Doanh nghiệp</Trans>
              </div>
              <div className="rounder1 absolute">
                <svg
                  width="86"
                  height="73"
                  viewBox="0 0 86 73"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M71.9429 9.75945C77.9382 9.77498 85.5153 8.61899 85.5058 12.2813L85.3669 65.8836C85.3574 69.5459 80.4896 72.5022 74.4943 72.4866L19.3124 72.3437C8.4569 72.3155 8.4569 72.3156 8.47408 65.6843C3.95097 65.6726 65.8023 65.8329 71.7976 65.8484L71.9429 9.75945Z"
                    fill="#2F7DBF"
                  />
                  <path
                    d="M67.895 0.907423C73.8903 0.922956 78.7428 3.90444 78.7333 7.56676L78.5944 61.169C78.585 64.8313 73.7171 67.7876 67.7218 67.7721L12.5399 67.6292C6.54456 67.6136 1.6921 64.6321 1.70159 60.9698C-7.34463 60.9464 67.739 61.1409 67.739 61.1409L67.895 0.907423Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="rounder absolute">
                <svg
                  width="130"
                  height="94"
                  viewBox="0 0 130 94"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.9998 15C15.9998 8.37258 13.8723 0 20.4998 0H117.5C124.127 0 129.5 5.37258 129.5 12V73C129.5 85 129.5 85 117.5 85C117.5 90 117.5 21.6274 117.5 15H15.9998Z"
                    fill="#2F7DBF"
                  />
                  <path
                    d="M0 19.5C0 12.8726 5.37258 7.5 12 7.5H109C115.627 7.5 121 12.8726 121 19.5V80.5C121 87.1274 115.627 92.5 109 92.5C109 102.5 109 19.5 109 19.5H0Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </Link>
        </>
      )}
      {type == 3 && (
        <>
          <Link
            to={`?type=1${redirectParam ? '&redirect=' + redirectParam : ''}`}
          >
            <div className="flex items-center item-selection cursor-pointer relative">
              <svg
                width="9"
                height="20"
                viewBox="0 0 9 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.27586 4.40327C5.49179 4.40327 6.47749 3.41757 6.47749 2.20164C6.47749 0.985706 5.49179 0 4.27586 0C3.05993 0 2.07422 0.985706 2.07422 2.20164C2.07422 3.41757 3.05993 4.40327 4.27586 4.40327Z"
                  fill="#2F7DBF"
                />
                <path
                  d="M5.70003 5.03736H2.85001C2.12589 5.00836 1.41972 5.26708 0.88572 5.75702C0.351724 6.24696 0.0333017 6.92831 0 7.65224V11.3929C0.0113229 11.8151 0.154962 12.2232 0.410644 12.5594C0.666326 12.8956 1.02114 13.143 1.42501 13.2668V18.3683C1.40141 18.7727 1.5375 19.1703 1.80399 19.4754C2.07048 19.7805 2.44609 19.9689 2.85001 19.9999H5.70003C6.10396 19.9689 6.47957 19.7805 6.74606 19.4754C7.01255 19.1703 7.14863 18.7727 7.12504 18.3683V13.2668C7.52891 13.143 7.88372 12.8956 8.1394 12.5594C8.39508 12.2232 8.53872 11.8151 8.55004 11.3929V7.65224C8.51674 6.92831 8.19832 6.24696 7.66433 5.75702C7.13033 5.26708 6.42415 5.00836 5.70003 5.03736V5.03736Z"
                  fill="#2F7DBF"
                />
              </svg>

              <div style={{ marginLeft: '13px' }}>
                <Trans>Cá nhân</Trans>
              </div>
            </div>
          </Link>
          <Link
            to={`?type=2${redirectParam ? '&redirect=' + redirectParam : ''}`}
          >
            <div className=" flex items-center item-selection cursor-pointer relative">
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.4266 7.60216C11.5514 7.60216 11.6716 7.62221 11.7874 7.65561L13.9475 5.00779C14.0856 4.83855 14.3417 4.80737 14.5087 4.94989C14.6713 5.08574 14.6935 5.32847 14.5577 5.49326L12.4221 8.11213C12.5668 8.31255 12.6537 8.55977 12.6537 8.827C12.6537 9.3236 12.3553 9.7534 11.9299 9.94489H20.3098C20.6172 9.94489 20.8666 9.6955 20.8666 9.38816V2.33993C20.8666 2.03262 20.6172 1.7832 20.3098 1.7832H9.66513C9.35781 1.7832 9.1084 2.03262 9.1084 2.33993V6.96749L9.61168 7.60439H11.4266V7.60216Z"
                  fill="#007CC2"
                />
                <path
                  d="M4.4835 4.56075C5.74292 4.56075 6.76387 3.53979 6.76387 2.28037C6.76387 1.02096 5.74292 0 4.4835 0C3.22408 0 2.20312 1.02096 2.20312 2.28037C2.20312 3.53979 3.22408 4.56075 4.4835 4.56075Z"
                  fill="#007CC2"
                />
                <path
                  d="M6.82108 19.4431C6.82108 19.7505 6.57166 19.9999 6.26435 19.9999H5.32904C5.02172 19.9999 4.77231 19.7505 4.77231 19.4431V14.7755C4.77231 14.6107 4.63869 14.4771 4.4739 14.4771C4.30911 14.4771 4.17549 14.6107 4.17549 14.7755V19.4209C4.17549 19.7393 3.91494 19.9999 3.59649 19.9999H2.68122C2.37391 19.9999 2.12449 19.7505 2.12449 19.4431L2.12004 8.17489C2.12004 8.02346 1.99755 7.89877 1.8439 7.89877C1.69247 7.89877 1.56776 8.02125 1.56776 8.17489V12.5085C1.56776 12.8158 1.31834 13.0652 1.01103 13.0652H0.556732C0.249416 13.0652 0 12.8158 0 12.5085V6.56705C0 5.86111 0.57232 5.29102 1.27603 5.29102H6.34674C6.89009 5.29102 7.40454 5.54043 7.74303 5.96578L9.10589 7.68496L9.39316 8.04795C9.39316 8.04795 10.6848 8.04795 11.4286 8.05018C11.7359 8.05018 11.9853 8.2996 11.9853 8.60691V9.05007C11.9853 9.35739 11.7359 9.6068 11.4286 9.6068H9.01906C8.78078 9.6068 8.55586 9.49768 8.40888 9.3106L7.3934 8.00562C7.34218 7.93881 7.25979 7.89873 7.17516 7.89873H7.10613C6.9547 7.89873 6.83001 8.02121 6.83001 8.17484L6.82108 19.4431Z"
                  fill="#007CC2"
                />
              </svg>

              <div style={{ marginLeft: '13px' }}>
                <Trans>Nhà trường</Trans>
              </div>
            </div>
          </Link>
          <div className=" item-selection active cursor-pointer relative">
            <Link
              to={`?type=3${redirectParam ? '&redirect=' + redirectParam : ''}`}
            >
              <div className="flex items-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.51562 7.10938C2.22301 7.10938 1.17188 6.05824 1.17188 4.76562C1.17188 3.47301 2.22301 2.42188 3.51562 2.42188C4.80824 2.42188 5.85938 3.47301 5.85938 4.76562C5.85938 6.05824 4.80824 7.10938 3.51562 7.10938Z"
                    fill="white"
                  />
                  <path
                    d="M16.4844 7.10938C15.1918 7.10938 14.1406 6.05824 14.1406 4.76562C14.1406 3.47301 15.1918 2.42188 16.4844 2.42188C17.777 2.42188 18.8281 3.47301 18.8281 4.76562C18.8281 6.05824 17.777 7.10938 16.4844 7.10938Z"
                    fill="white"
                  />
                  <path
                    d="M10 5.85938C8.38465 5.85938 7.07031 4.54504 7.07031 2.92969C7.07031 1.31434 8.38465 0 10 0C11.6154 0 12.9297 1.31434 12.9297 2.92969C12.9297 4.54504 11.6154 5.85938 10 5.85938Z"
                    fill="white"
                  />
                  <path
                    d="M10.5859 5.91797V9.96032C10.5859 10.2842 10.3239 10.5463 10 10.5463C9.67613 10.5463 9.41406 10.2842 9.41406 9.96032V5.91797C7.43164 6.20535 5.89844 7.89957 5.89844 9.96032V13.4759C5.89844 13.7998 6.16051 14.0619 6.48438 14.0619H7.79703L8.24449 19.4627C8.26965 19.7659 8.52371 19.9994 8.82812 19.9994H11.1719C11.4763 19.9994 11.7304 19.7659 11.7555 19.4627L12.203 14.0619H13.5156C13.8395 14.0619 14.1016 13.7998 14.1016 13.4759V9.96032C14.1016 7.89957 12.5684 6.20535 10.5859 5.91797V5.91797Z"
                    fill="white"
                  />
                  <path
                    d="M4.6875 13.5547V10.0391C4.6875 9.16078 4.92383 8.34461 5.30512 7.61555C4.77898 7.30148 4.17164 7.10938 3.51562 7.10938C1.57699 7.10938 0 8.68637 0 10.625V13.5547C0 13.8786 0.26207 14.1406 0.585938 14.1406H1.22738L1.76066 19.4724C1.79043 19.7717 2.04277 20 2.34375 20H4.6875C4.98848 20 5.24082 19.7717 5.27059 19.4724L5.70367 15.1426C5.10543 14.8619 4.6875 14.2581 4.6875 13.5547V13.5547Z"
                    fill="white"
                  />
                  <path
                    d="M19.9996 10.625C19.9996 8.68637 18.4226 7.10938 16.4839 7.10938C15.8279 7.10938 15.2206 7.30148 14.6945 7.61555C15.0757 8.34461 15.3121 9.16078 15.3121 10.0391V13.5547C15.3121 14.2581 14.8941 14.8619 14.2959 15.1426L14.729 19.4724C14.7588 19.7717 15.0111 20 15.3121 20H17.6558C17.9568 20 18.2091 19.7717 18.2389 19.4724L18.7722 14.1406H19.4136C19.7375 14.1406 19.9996 13.8786 19.9996 13.5547V10.625Z"
                    fill="white"
                  />
                </svg>

                <div style={{ marginLeft: '13px', color: '#FFF' }}>
                  <Trans>Doanh nghiệp</Trans>
                </div>
              </div>
            </Link>

            <div className="rounder1 absolute">
              <svg
                width="86"
                height="73"
                viewBox="0 0 86 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M71.9429 9.75945C77.9382 9.77498 85.5153 8.61899 85.5058 12.2813L85.3669 65.8836C85.3574 69.5459 80.4896 72.5022 74.4943 72.4866L19.3124 72.3437C8.4569 72.3155 8.4569 72.3156 8.47408 65.6843C3.95097 65.6726 65.8023 65.8329 71.7976 65.8484L71.9429 9.75945Z"
                  fill="#2F7DBF"
                />
                <path
                  d="M67.895 0.907423C73.8903 0.922956 78.7428 3.90444 78.7333 7.56676L78.5944 61.169C78.585 64.8313 73.7171 67.7876 67.7218 67.7721L12.5399 67.6292C6.54456 67.6136 1.6921 64.6321 1.70159 60.9698C-7.34463 60.9464 67.739 61.1409 67.739 61.1409L67.895 0.907423Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="rounder absolute">
              <svg
                width="130"
                height="94"
                viewBox="0 0 130 94"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9998 15C15.9998 8.37258 13.8723 0 20.4998 0H117.5C124.127 0 129.5 5.37258 129.5 12V73C129.5 85 129.5 85 117.5 85C117.5 90 117.5 21.6274 117.5 15H15.9998Z"
                  fill="#2F7DBF"
                />
                <path
                  d="M0 19.5C0 12.8726 5.37258 7.5 12 7.5H109C115.627 7.5 121 12.8726 121 19.5V80.5C121 87.1274 115.627 92.5 109 92.5C109 102.5 109 19.5 109 19.5H0Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </>
      )}
      {type == 2 && (
        <>
          <Link
            to={`?type=1${redirectParam ? '&redirect=' + redirectParam : ''}`}
          >
            <div className="flex items-center item-selection cursor-pointer relative">
              <svg
                width="9"
                height="20"
                viewBox="0 0 9 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.27586 4.40327C5.49179 4.40327 6.47749 3.41757 6.47749 2.20164C6.47749 0.985706 5.49179 0 4.27586 0C3.05993 0 2.07422 0.985706 2.07422 2.20164C2.07422 3.41757 3.05993 4.40327 4.27586 4.40327Z"
                  fill="#2F7DBF"
                />
                <path
                  d="M5.70003 5.03736H2.85001C2.12589 5.00836 1.41972 5.26708 0.88572 5.75702C0.351724 6.24696 0.0333017 6.92831 0 7.65224V11.3929C0.0113229 11.8151 0.154962 12.2232 0.410644 12.5594C0.666326 12.8956 1.02114 13.143 1.42501 13.2668V18.3683C1.40141 18.7727 1.5375 19.1703 1.80399 19.4754C2.07048 19.7805 2.44609 19.9689 2.85001 19.9999H5.70003C6.10396 19.9689 6.47957 19.7805 6.74606 19.4754C7.01255 19.1703 7.14863 18.7727 7.12504 18.3683V13.2668C7.52891 13.143 7.88372 12.8956 8.1394 12.5594C8.39508 12.2232 8.53872 11.8151 8.55004 11.3929V7.65224C8.51674 6.92831 8.19832 6.24696 7.66433 5.75702C7.13033 5.26708 6.42415 5.00836 5.70003 5.03736V5.03736Z"
                  fill="#2F7DBF"
                />
              </svg>
              <div style={{ marginLeft: '13px' }}>
                <Trans>Cá nhân</Trans>
              </div>
            </div>
          </Link>

          <div className=" active item-selection cursor-pointer relative">
            <Link
              to={`?type=2${redirectParam ? '&redirect=' + redirectParam : ''}`}
            >
              <div
                href="/user/signup?role=university"
                className="flex items-center"
              >
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.4266 7.60216C11.5514 7.60216 11.6716 7.62221 11.7874 7.65561L13.9475 5.00779C14.0856 4.83855 14.3417 4.80737 14.5087 4.94989C14.6713 5.08574 14.6935 5.32847 14.5577 5.49326L12.4221 8.11213C12.5668 8.31255 12.6537 8.55977 12.6537 8.827C12.6537 9.3236 12.3553 9.7534 11.9299 9.94489H20.3098C20.6172 9.94489 20.8666 9.6955 20.8666 9.38816V2.33993C20.8666 2.03262 20.6172 1.7832 20.3098 1.7832H9.66513C9.35781 1.7832 9.1084 2.03262 9.1084 2.33993V6.96749L9.61168 7.60439H11.4266V7.60216Z"
                    fill="white"
                  />
                  <path
                    d="M4.4835 4.56075C5.74292 4.56075 6.76387 3.53979 6.76387 2.28037C6.76387 1.02096 5.74292 0 4.4835 0C3.22408 0 2.20312 1.02096 2.20312 2.28037C2.20312 3.53979 3.22408 4.56075 4.4835 4.56075Z"
                    fill="white"
                  />
                  <path
                    d="M6.82108 19.4431C6.82108 19.7505 6.57166 19.9999 6.26435 19.9999H5.32904C5.02172 19.9999 4.77231 19.7505 4.77231 19.4431V14.7755C4.77231 14.6107 4.63869 14.4771 4.4739 14.4771C4.30911 14.4771 4.17549 14.6107 4.17549 14.7755V19.4209C4.17549 19.7393 3.91494 19.9999 3.59649 19.9999H2.68122C2.37391 19.9999 2.12449 19.7505 2.12449 19.4431L2.12004 8.17489C2.12004 8.02346 1.99755 7.89877 1.8439 7.89877C1.69247 7.89877 1.56776 8.02125 1.56776 8.17489V12.5085C1.56776 12.8158 1.31834 13.0652 1.01103 13.0652H0.556732C0.249416 13.0652 0 12.8158 0 12.5085V6.56705C0 5.86111 0.57232 5.29102 1.27603 5.29102H6.34674C6.89009 5.29102 7.40454 5.54043 7.74303 5.96578L9.10589 7.68496L9.39316 8.04795C9.39316 8.04795 10.6848 8.04795 11.4286 8.05018C11.7359 8.05018 11.9853 8.2996 11.9853 8.60691V9.05007C11.9853 9.35739 11.7359 9.6068 11.4286 9.6068H9.01906C8.78078 9.6068 8.55586 9.49768 8.40888 9.3106L7.3934 8.00562C7.34218 7.93881 7.25979 7.89873 7.17516 7.89873H7.10613C6.9547 7.89873 6.83001 8.02121 6.83001 8.17484L6.82108 19.4431Z"
                    fill="white"
                  />
                </svg>
                <div style={{ marginLeft: '13px', color: '#FFF' }}>
                  <Trans>Nhà trường</Trans>
                </div>
              </div>
            </Link>

            <div className="rounder1 absolute">
              <svg
                width="86"
                height="73"
                viewBox="0 0 86 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M71.9429 9.75945C77.9382 9.77498 85.5153 8.61899 85.5058 12.2813L85.3669 65.8836C85.3574 69.5459 80.4896 72.5022 74.4943 72.4866L19.3124 72.3437C8.4569 72.3155 8.4569 72.3156 8.47408 65.6843C3.95097 65.6726 65.8023 65.8329 71.7976 65.8484L71.9429 9.75945Z"
                  fill="#2F7DBF"
                />
                <path
                  d="M67.895 0.907423C73.8903 0.922956 78.7428 3.90444 78.7333 7.56676L78.5944 61.169C78.585 64.8313 73.7171 67.7876 67.7218 67.7721L12.5399 67.6292C6.54456 67.6136 1.6921 64.6321 1.70159 60.9698C-7.34463 60.9464 67.739 61.1409 67.739 61.1409L67.895 0.907423Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="rounder absolute">
              <svg
                width="130"
                height="94"
                viewBox="0 0 130 94"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9998 15C15.9998 8.37258 13.8723 0 20.4998 0H117.5C124.127 0 129.5 5.37258 129.5 12V73C129.5 85 129.5 85 117.5 85C117.5 90 117.5 21.6274 117.5 15H15.9998Z"
                  fill="#2F7DBF"
                />
                <path
                  d="M0 19.5C0 12.8726 5.37258 7.5 12 7.5H109C115.627 7.5 121 12.8726 121 19.5V80.5C121 87.1274 115.627 92.5 109 92.5C109 102.5 109 19.5 109 19.5H0Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
          <Link
            to={`?type=3${redirectParam ? '&redirect=' + redirectParam : ''}`}
          >
            <div
              href="/user/signup?role=enterprise"
              className=" flex items-center item-selection cursor-pointer relative"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.51562 7.10938C2.22301 7.10938 1.17188 6.05824 1.17188 4.76562C1.17188 3.47301 2.22301 2.42188 3.51562 2.42188C4.80824 2.42188 5.85938 3.47301 5.85938 4.76562C5.85938 6.05824 4.80824 7.10938 3.51562 7.10938Z"
                  fill="#007CC2"
                />
                <path
                  d="M16.4844 7.10938C15.1918 7.10938 14.1406 6.05824 14.1406 4.76562C14.1406 3.47301 15.1918 2.42188 16.4844 2.42188C17.777 2.42188 18.8281 3.47301 18.8281 4.76562C18.8281 6.05824 17.777 7.10938 16.4844 7.10938Z"
                  fill="#007CC2"
                />
                <path
                  d="M10 5.85938C8.38465 5.85938 7.07031 4.54504 7.07031 2.92969C7.07031 1.31434 8.38465 0 10 0C11.6154 0 12.9297 1.31434 12.9297 2.92969C12.9297 4.54504 11.6154 5.85938 10 5.85938Z"
                  fill="#007CC2"
                />
                <path
                  d="M10.5859 5.91797V9.96032C10.5859 10.2842 10.3239 10.5463 10 10.5463C9.67613 10.5463 9.41406 10.2842 9.41406 9.96032V5.91797C7.43164 6.20535 5.89844 7.89957 5.89844 9.96032V13.4759C5.89844 13.7998 6.16051 14.0619 6.48438 14.0619H7.79703L8.24449 19.4627C8.26965 19.7659 8.52371 19.9994 8.82812 19.9994H11.1719C11.4763 19.9994 11.7304 19.7659 11.7555 19.4627L12.203 14.0619H13.5156C13.8395 14.0619 14.1016 13.7998 14.1016 13.4759V9.96032C14.1016 7.89957 12.5684 6.20535 10.5859 5.91797Z"
                  fill="#007CC2"
                />
                <path
                  d="M4.6875 13.5547V10.0391C4.6875 9.16078 4.92383 8.34461 5.30512 7.61555C4.77898 7.30148 4.17164 7.10938 3.51562 7.10938C1.57699 7.10938 0 8.68637 0 10.625V13.5547C0 13.8786 0.26207 14.1406 0.585938 14.1406H1.22738L1.76066 19.4724C1.79043 19.7717 2.04277 20 2.34375 20H4.6875C4.98848 20 5.24082 19.7717 5.27059 19.4724L5.70367 15.1426C5.10543 14.8619 4.6875 14.2581 4.6875 13.5547Z"
                  fill="#007CC2"
                />
                <path
                  d="M19.9996 10.625C19.9996 8.68637 18.4226 7.10938 16.4839 7.10938C15.8279 7.10938 15.2206 7.30148 14.6945 7.61555C15.0757 8.34461 15.3121 9.16078 15.3121 10.0391V13.5547C15.3121 14.2581 14.8941 14.8619 14.2959 15.1426L14.729 19.4724C14.7588 19.7717 15.0111 20 15.3121 20H17.6558C17.9568 20 18.2091 19.7717 18.2389 19.4724L18.7722 14.1406H19.4136C19.7375 14.1406 19.9996 13.8786 19.9996 13.5547V10.625Z"
                  fill="#007CC2"
                />
              </svg>
              <div style={{ marginLeft: '13px' }}>
                <Trans>Doanh nghiệp</Trans>
              </div>
            </div>
          </Link>
        </>
      )}
    </>
  );
};

export default MenuSignUp;
